<template>
  <NUIButton
    :obj="this.graph"
    :displayType="'icon'"
    id="graph-settings"
  />
</template>

<script>
import NUIButton from './nelsonUI/NUIButton.vue';
import { useModalStore } from '@/store/ModalStore';

export default {
  data () {
    return {
      graph: {
        label: 'Graph',
        icon: 'chart',
        value: 'graph',
        orientation: 'top',
        marker: 'var(--nelson-blue)',
        func: this.handleGraphSelection,
      }
    };
  },
  methods: {
    handleGraphSelection () {
      useModalStore().showModal('graph');
    }
  },
  components: {
    NUIButton
  }
};
</script>

<style scoped>  
</style>